<template>
    <a class="fa fa-question-circle" role="button" tabindex="-1" data-trigger="focus" data-toggle="popover"
        :title="title" :data-content="content"></a>
</template>

<script>
    export default {
        props: {
            title: String,
            content: String
        },
        mounted() {
            $(function () {
                $('[data-toggle="popover"]').popover()
            });
            $('.popover-dismiss').popover({
                trigger: 'focus'
            });
        },
    }
</script>